import { SearchBoxDesktop } from './SearchBoxDesktop';

export type { TypeSearchBoxDesktopProps } from './types';
export default SearchBoxDesktop;
